export default "__VITE_ASSET__DQ3Nw_PS__"